import { mergeAttributes, Node } from '@tiptap/core';


/** add Countdown component integration */
export const CountDownEditor_server = Node.create({
    name: 'CountDown',
    group: 'block',
    atom: true,
    draggable: true,
    selectable: true,
    addAttributes() {
        return {
            date: {
                default: new Date().toISOString(), // Use ISO string for serialization
            },
        };
    },
    parseHTML() {
        return [{ tag: 'CountDown' }];
    },


    renderHTML({ HTMLAttributes }) {
        const date = new Date(HTMLAttributes.date);
        return ['div', mergeAttributes(HTMLAttributes,
            { "class": `text-4xl w-1em my-4 mx-auto aspect-square rounded-full animate-spin border-y-2 border-solid border-current border-t-transparent shadow-lg text-nfPurple-400` }),
        ];
    },
})
/** render logic is outside of server side extension as it breaks the nextjs SSR */